import React from 'react'

export const IntegrationHome: React.VFC = () => {
  return null
}
